import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import classNames from 'classnames';
import styles from './StoryTile.module.styl';
import sizeImage from '../lib/sizeImage';
import makeSrcSet from '../lib/makeSrcSet';

const StoryTile = ({
  image,
  headline,
  href,
  imgAlt,
  isDisplayed,
  aspectRatio,
}) => {
  const imageSet = {
    large: sizeImage({
      src: image,
      widthAspect: aspectRatio,
      width: 1080,
    }),
    small: sizeImage({
      src: image,
      widthAspect: aspectRatio,
      width: 640,
    }),
  };

  const srcSet = makeSrcSet(image, undefined, { widthAspect: aspectRatio });

  return (
    <li className={classNames(styles.storyTile, { [styles.isDisplayed]: isDisplayed })}>
      <Link to={href} className={styles.tileLink}>
        <figure className={styles.tileBody}>
          <picture>
            <img
              src={imageSet.placeholder}
              alt={imgAlt}
              data-object-fit="cover"
              srcSet={srcSet}
              sizes="(max-width: 35em) 100vw; (max-width: 68em) 50vw; 16.5vw"
            />
          </picture>

          <figcaption>
            <h2 className={classNames(styles.headline, 'bentoncond-n4')}>
              {headline}
            </h2>
          </figcaption>
        </figure>
      </Link>
    </li>
  );
};

StoryTile.propTypes = {
  headline: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool,
  aspectRatio: PropTypes.number,
};

StoryTile.defaultProps = {
  isDisplayed: false,
  aspectRatio: null,
};

export default StoryTile;
